import common from '@page/common/js/common';
import { createApp } from 'vue';
import LazyPlugin from '@global/composable/lazyload';

import ArticleIndex from '@page/article/components/Article.vue';

const app = createApp({
  components: {
    ArticleIndex,
  },
});

app.use(LazyPlugin);
app.mount('#article-index');
